import { Pipe, PipeTransform } from '@angular/core';
import { IFilterItemViewModel } from '@ncg/data';
import { Favorites } from './favorites';

@Pipe({
    name: 'isFavorite',
})
export class IsFavoritePipe implements PipeTransform {
    transform(favorites: Favorites | null, id: IFilterItemViewModel['id']): boolean {
        return favorites?.some((favorite) => favorite.id === id) || false;
    }
}
